import classnames from 'classnames';
import defaultMenuRenderer from 'react-select/lib/utils/defaultMenuRenderer';
import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import scrollLock from 'components/lib/util/scroll_lock_handler';
import TetherComponent from 'react-tether';

const MultiSelect = ({
  className,
  options,
  initialSelectedOptions,
  placeholder,
  onChange,
  filterOption,
  optionRenderer,
  valueRenderer,
  valueComponent,
}) => {
  let classes = classnames('multiSelect', className);
  let selectedOptionValues = initialSelectedOptions.map(option => option.id);
  return (
    <ReactSelect
      backspaceToRemoveMessage=""
      className={classes}
      clearable={false}
      filterOption={filterOption}
      matchProp="label"
      menuRenderer={makeTetheredMenuRenderer({ className })}
      multi
      onChange={onChange}
      optionRenderer={optionRenderer}
      options={options}
      placeholder={placeholder}
      value={selectedOptionValues}
      valueKey="id"
      valueRenderer={valueRenderer}
      valueComponent={valueComponent}
    />
  );
};

export function makeTetheredMenuRenderer({ className }) {
  let classes = classnames('tetheredMultiselectMenu', className);
  return menuOptions => {
    return (
      <TetherComponent
        attachment="top left"
        targetAttachment="bottom left"
        constraints={[{ to: 'window', attachment: 'together' }]}
      >
        <div className="tetheredMultiselectMenuAnchor" />
        <div className={classes}>
          <div className="Select-menu-outer">
            <div className="Select-menu" onWheel={scrollLock}>
              {defaultMenuRenderer(menuOptions)}
            </div>
          </div>
        </div>
      </TetherComponent>
    );
  };
}

let optionPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
});

MultiSelect.propTypes = {
  className: PropTypes.string,
  initialSelectedOptions: PropTypes.arrayOf(optionPropType),
  options: PropTypes.arrayOf(optionPropType).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  filterOption: PropTypes.func,
  optionRenderer: PropTypes.func,
  valueRenderer: PropTypes.func,
  valueComponent: PropTypes.func,
};

MultiSelect.defaultProps = {
  initialSelectedOptions: [],
  placeholder: '',
};

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/multi_select.jsx